<template>
  <div class="lztZnstyPage">
    <div class="lztJpg">
      <img :src="baseUrl+'lztZnsty.png'" alt />
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "lztZnsty",
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      clientType: "" //手机类型
    };
  },
  mounted() {
    this.clientType = getDeviceType();
  },
  methods: {}
};
</script>
<style lang="less">
.lztZnstyPage {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    min-height: 100%;
  }
}
</style>